// extracted by mini-css-extract-plugin
export var option = "_4r-1";
export var optionActive = "_4r-2";
export var pill = "_4r-0";